import { gql } from "@apollo/client";
export const SearchWorkerCollectionEntries = gql`
  mutation SearchWorkerCollection($request: SearchWorkerCollectionRequest!) {
    SearchWorkerCollection(request: $request) {
      data
      total
    }
  }
`;

export const workerCollectionData = gql`
  query WorkerCollection(
    $pageSize: Int
    $pageNumber: Int
    $order: String
    $sort: String
    $service: String
  ) {
    WorkerCollection(
      pageSize: $pageSize
      pageNumber: $pageNumber
      order: $order
      sort: $sort
      service: $service
    ) {
      data
      total
    }
  }
`;

export const CreateWorkerCollectionEntry = gql`
  mutation CreateWorkerCollection($collection: CollectionInput) {
    CreateWorkerCollection(collection: $collection) {
      data
    }
  }
`;

export const UpdateWorkerCollection = gql`
  mutation UpdateWorkerCollection($collection: CollectionInput, $id: String) {
    UpdateWorkerCollection(collection: $collection, id: $id) {
      data
    }
  }
`;

export const deleteWorkerCollection = gql`
  mutation DeleteWorkerCollection($id: String) {
    DeleteWorkerCollection(id: $id) 
  }
`;
